/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import { FiraSansBold } from 'components/Text';
import { Breakpoints } from 'constants/Breakpoints';

export const Scrollbox = styled.div` 
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 500px;
  padding:10px 20px 10px 10px;
  
  ::-webkit-scrollbar{
    background:${Colors.WHITE};
    width:8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
  `;

export const Footer = styled.div`
display: flex;
justify-content: space-between;
margin-top: 20px;  
`;

export const Text = styled.label`
  font-size: 16px;
  font-weight: bold;
  color: ${Colors.GRAY[2]};
  overflow: hidden;
  white-space: nowrap;
  line-height: 150%;
  text-overflow: ellipsis;
  margin-left: 8px;
`;

export const Title = styled.label`
  font-size: 16px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
  `;

export const ButtonContent = styled.div`
  display:flex;
  background-color: ${Colors.WHITE};  
  flex-direction: row;
  justify-content: space-evenly;
  
  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 10px;
    width: 100%;
  }
`;